<form
  name="form"
  autocomplete="off"
  class="tab-segments field-dialog__content__scroll"
  [class.with-disclaimer]="isViewMode"
  fusePerfectScrollbar
>
  <disclaimer *ngIf="isViewMode" [message]="'GROUPS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
  <disclaimer *ngIf="!isViewMode" [message]="'GROUPS.DIALOG.TABS.SEGMENTS.DISCLAIMER' | translate"> </disclaimer>

  <div class="tab-segments__title-wrapper">
    <p class="tab-segments__title-text">
      {{ 'GROUPS.DIALOG.TABS.SEGMENTS.LINKED.TITLE' | translate }} ({{ linkedSegmentsCount }})
    </p>
  </div>

  <ng-container *ngIf="isLoading; else pageTemplate">
    <div class="loading">
      <mat-spinner class="loading__spinner" diameter="64"></mat-spinner>
      <span class="loading__text"> {{ 'GROUPS.DIALOG.TABS.SEGMENTS.LOADING' | translate }}</span>
    </div>
  </ng-container>

  <ng-template #pageTemplate>
    <div class="tab-segments__body">
      <div class="select-list" *ngIf="segments.length; else noSegments">
        <div class="select-list__select-all">
          <mat-checkbox
            [checked]="isAllSelected"
            [disabled]="isSaving.length || isViewMode || group.locked"
            [class.disabled]="isSaving.length || isViewMode || group.locked"
            (change)="toggleAll($event.checked)"
          >
            {{ 'GROUPS.DIALOG.TABS.SEGMENTS.SELECT_ALL' | translate }}
          </mat-checkbox>
        </div>
        <div class="select-list__item" *ngFor="let segment of segments">
          <mat-checkbox
            [checked]="segment.groupsConnection.items.length"
            [disabled]="segment['isSaving'] || isViewMode || group.locked"
            [class.disabled]="segment['isSaving'] || isViewMode || group.locked"
            (change)="toggleSegmentLinkedToGroup($event.checked, [segment])"
          >
            {{ segment.name }}
            <span *ngIf="segment.archived" class="select-list__item-archived">
              ({{ 'GROUPS.DIALOG.TABS.SEGMENTS.LINKED.ARCHIVED' | translate }})
            </span>
          </mat-checkbox>
          <mat-spinner color="primary" diameter="20" *ngIf="segment['isSaving']"></mat-spinner>
        </div>
      </div>
      <ng-template #noSegments>
        <p class="tab-segments__body__not-found-title">
          {{ 'GROUPS.DIALOG.TABS.SEGMENTS.LINKED.NOT_FOUND' | translate }}
        </p>
      </ng-template>
    </div>
  </ng-template>
</form>
